//NotificationView.jsx
import React, { useState, useEffect } from "react";
import { Typography, Paper } from "@mui/material";
import NotificationForm from "./NotificationForm";
import NotificationTable from "./NotificationTable";
import { BglLoading } from "components/loading/BglLoading"; // Loading component
import { useGlobalConfig } from "context/GlobalContext";

export const NotificationView = () => {
  const { rc } = useGlobalConfig();
  const [pilotId, setPilotId] = useState();
  const [startTime, setStartTime] = useState(Math.floor((Date.now() - 2 * 24 * 60 * 60 * 1000))); // 2 days ago in epoch (seconds)
  const [endTime, setEndTime] = useState(Math.floor(Date.now())); // current time in epoch (seconds)

  const [eventName, setEventName] = useState("");
  const [customEventName] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [notificationError, setNotificationError] = useState("");
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [notificationsPerPage, setNotificationsPerPage] = useState(100);

  const [partnerUserId, setPartnerUserId] = useState("");
  const [userId, setUserId] = useState("");


  const handleFetchNotifications = async () => {
    console.log("Fetching notifications...");
    const hasIdentifier = partnerUserId || userId || pilotId;
    const hasRequiredFields = notificationStatus && (customEventName || eventName);
    if (!hasIdentifier || !hasRequiredFields) {
      console.log("Form validation failed.");
      setNotificationError('Please fill all required fields');
      return;
    }
    
      setIsLoading(true);
      //Logging the filters being sent
      console.log("Filters:", {
        pilotId,
        startTime: Math.floor(startTime / 1000),
        endTime: Math.floor(endTime / 1000),
        offset: (currentPage - 1) * notificationsPerPage,
        limit: notificationsPerPage,
        eventName: customEventName || eventName,
        notificationStatus,
      });

      // Construct the base URL
      // const finalUrl = `/2.1/utility_notifications/${pilotId}/fetch-notifications?startTime=${Math.floor(startTime/1000)}&endTime=${Math.floor(endTime/1000)}&offset=${
      //   (currentPage - 1)*notificationsPerPage
      // }&limit=${notificationsPerPage}&eventName=${
      //   customEventName || eventName
      // }&notificationStatus=${notificationStatus}`;
      
      let finalUrl;
      if (partnerUserId) {
        finalUrl = `/2.1/utility_notifications/fetch-notifications-for-user?partnerUserId=${partnerUserId}&startTime=${Math.floor(startTime / 1000)}&endTime=${Math.floor(endTime / 1000)}&notificationStatus=${notificationStatus}&eventName=${customEventName || eventName}`;
      } else if (userId) {
        finalUrl = `/2.1/utility_notifications/fetch-notifications-for-user?userID=${userId}&startTime=${Math.floor(startTime / 1000)}&endTime=${Math.floor(endTime / 1000)}&notificationStatus=${notificationStatus}&eventName=${customEventName || eventName}`;
      } else {
        finalUrl = `/2.1/utility_notifications/${pilotId}/fetch-notifications?startTime=${Math.floor(startTime / 1000)}&endTime=${Math.floor(endTime / 1000)}&offset=${
          (currentPage - 1) * notificationsPerPage
        }&limit=${notificationsPerPage}&eventName=${
          customEventName || eventName
        }&notificationStatus=${notificationStatus}`;
      }

      console.log("API URL:", finalUrl);
    
      let response, data;
      try {
        response = await rc.apiClient.get(finalUrl);
        data = response?.data;
        console.log("API Response:", data);
      } catch (err) {
        console.error("API Error:", err);
        setIsLoading(false);
        setNotifications([]);
        setTotalNotifications(0);
        setNotificationError("There is some issue in the API endpoint. Note: Do not include https in the endpoint.");
        return;
      }
    
      if (response.error) {
        console.error("Response Error:", response.error);
        setIsLoading(false);
        setNotifications([]);
        setTotalNotifications(0);
        setNotificationError(response.error);
        return;
      }
    
      console.log("Notifications fetched:", data?.userNotificationStatusBeanList?.length); // Debugging log
    
      setNotificationError(undefined);
      setNotifications(data?.userNotificationStatusBeanList || []); // Ensure it's an array
      setTotalNotifications(data?.totalNotificationCount || 0); // Ensure it's a number
      // setNotifications(data?.payload?.userNotificationStatusBeanList || []); // Ensured it's an array and Fixed nested payload
      // setTotalNotifications(data?.payload?.totalNotificationCount || 0); // same here
      setIsLoading(false);
    };

  useEffect(() => {
    console.log("currentPage", currentPage)
    handleFetchNotifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage,notificationsPerPage]);


  return (
    <div>
      <Typography gutterBottom>
        Email Preview Form{" "}
      </Typography>
      <NotificationForm
        pilotId={pilotId}
        setPilotId={setPilotId}
        startTime={startTime}
        setStartTime={setStartTime}
        endTime={endTime}
        setEndTime={setEndTime}
        eventName={eventName}
        setEventName={setEventName}
        notificationStatus={notificationStatus}
        setNotificationStatus={setNotificationStatus}
        onFetchNotifications={handleFetchNotifications}
        partnerUserId={partnerUserId}
        setPartnerUserId={setPartnerUserId}
        userId={userId}
        setUserId={setUserId}
      />
      {isLoading ? (
        <BglLoading />
      ) : notificationError ? (
        <Typography variant="body1" color="error">
          {notificationError?.message || notificationError}
        </Typography>
      ) : (
        <Paper style={{ marginTop: "16px", padding: "16px" }}>

          {/* Adding this line to display the total */}
          <Typography variant="body1" style={{ marginBottom: "16px" }}>
            Total Notifications: {totalNotifications}
          </Typography>

          {notifications && (
            <NotificationTable
              notifications={notifications}
              selectedNotifications={selectedNotifications}
              setSelectedNotifications={setSelectedNotifications}
              currentPage={currentPage}
              totalNotifications={totalNotifications}
              notificationsPerPage={notificationsPerPage}
              onPageChange={(pageChange)=> {setCurrentPage(pageChange)}}
              pilotId={pilotId}
              handleFetchNotifications={handleFetchNotifications}
              setNotificationsPerPage={setNotificationsPerPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Paper>
      )}
    </div>
  );
};

export default NotificationView;